// extracted by mini-css-extract-plugin
export default {"headerMobile":"navigation-mobile_headerMobile__oQhGu","active":"navigation-mobile_active__4igvo"};